import { ChangeDetectionStrategy, Component, ChangeDetectorRef, InjectionToken, Inject } from '@angular/core';
import { AdminEditColumnStorage } from './../admin-edit-column-storage';
import { MdlDialogReference } from '@angular-mdl/core';
import { DefaultColumnInfo, FormResultInfo, FormResultType } from '../admin-edit-column-info';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { FormDropdown } from '../../../sample-tracking/sample-monitoring/interface/notification-data';
import { notNullOrWhiteSpace } from '../../../shared/validators';
import { ModalDialogService } from '../../../shared/model-dialog/modal-dialog.service';
import { DeleteModalData } from '../../../shared/model-dialog/delete/delete-modal.component';
export const COLUMN_INFO_TOKEN = new InjectionToken('ColumnSettingItem');

@Component({
    selector: 'admin-column-form',
    template: require('./admin-column-form.component.html'),
    styles: [require('./admin-column-form.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminColumnFormComponent {

    public editForm: FormGroup;
    public columnViewInfo: DefaultColumnInfo;
    public datatypeList: FormDropdown[] = [{ key: 1, value: 'string' }, { key: 2, value: 'long' }, { key: 3, value: 'datetime' }, { key: 4, value: 'date' }, { key: 5, value: 'time' }];
    public selectedDataType: FormDropdown[];
    public hyperlinkField = false;
    public defaultField = false;
    public mandatoryField = false;
    public hiddenField = false;

    constructor(
        public adminEditStorage: AdminEditColumnStorage,
        public changeDetectorRef: ChangeDetectorRef,
        public formBuilder: FormBuilder,
        private dialogReference: MdlDialogReference,
        private deleteDialogService: ModalDialogService,
        @Inject(COLUMN_INFO_TOKEN) private readonly columnInfo: DefaultColumnInfo
    ) {
        this.columnViewInfo = columnInfo;
        this.editForm = this.getColumnForm(this.columnViewInfo);

    }

    public async onDeleteClick() {
        let data: DeleteModalData = {
            title: 'Confirm Deletion',
            content: `Are you sure you want to delete this column <b>` + this.columnViewInfo.columnDisplayName + `</b> ? <br> <br>
                <b> Note: </b>This action cannot be undone.`,
            closeButtonText: 'Cancel',
            deleteButtonText: 'Delete'
        };
        let result = await this.deleteDialogService.showCustomDeleteDialog(data).toPromise();
        if (result && result.isDeleted) {
            let columnInfo = this.getColumnInfo();
            this.closeDialog(FormResultType.delete, columnInfo);
        }
    }

    public onCancelClick() {
        this.closeDialog(FormResultType.cancel, null);
    }

    public onApplyClick() {
        let updatedColumnInfo = this.getColumnInfo();
        this.closeDialog(FormResultType.save, updatedColumnInfo);
    }

    public getFormControl(name: string) {
        return this.editForm.get(name) as FormControl;
    }

    public onDataTypeSelected($event: FormDropdown[]) {
        this.selectedDataType = $event;
    }

    private getColumnForm(data: DefaultColumnInfo) {
        if (data) {
            this.selectedDataType = this.datatypeList.filter(t => t.lable === data.dataType);
            this.defaultField = data.defaultFlag;
            this.mandatoryField = data.mandatoryFlag;
            this.hyperlinkField = data.hyperlinkFlag;
            this.hiddenField = data.hiddenFlag;
        }
        return this.formBuilder.group({
            'columnDisplayName': new FormControl(data ? data.columnDisplayName : '', [Validators.required, notNullOrWhiteSpace()]),
            'dbViewColumnName': new FormControl(data ? data.dbViewColumnName : '', [Validators.required, notNullOrWhiteSpace()]),
            'dataType': new FormControl(data ? data.dataType : '', [Validators.required, notNullOrWhiteSpace()]),
            'formatString': new FormControl(data ? data.formatString : ''),
            'sequence': new FormControl(data ? data.sequence : ''),
            'hyperlinkRoute': new FormControl(data ? data.hyperlinkRoute : ''),
            'actionDbColumnName': new FormControl(data ? data.actionDbColumnName : ''),
            'entity': new FormControl(data ? data.entity : ''),
            'entityAttribute': new FormControl(data ? data.entityAttribute : ''),
            'physicalEntity': new FormControl(data ? data.physicalEntity : ''),
            'physicalEntityAttribute': new FormControl(data ? data.physicalEntityAttribute : ''),
            'customSQL': new FormControl(data ? data.customSQL : ''),
        });
    }

    private closeDialog(formType: FormResultType, columnInfo: DefaultColumnInfo) {
        let result: FormResultInfo = {
            resultType: formType,
            columnInfo: columnInfo
        };
        this.dialogReference.hide(result);
    }

    private getColumnInfo() {
        let updatedColumnInfo: DefaultColumnInfo = this.editForm.getRawValue();
        updatedColumnInfo.defaultFlag = this.defaultField;
        updatedColumnInfo.hiddenFlag = this.hiddenField;
        updatedColumnInfo.mandatoryFlag = this.mandatoryField;
        updatedColumnInfo.hyperlinkFlag = this.hyperlinkField;
        if (this.columnViewInfo) {
            updatedColumnInfo.appDataDefinitionId = this.columnViewInfo.appDataDefinitionId;
            updatedColumnInfo.appDataColumnDefinitionId = this.columnViewInfo.appDataColumnDefinitionId;
        }
        return updatedColumnInfo;
    }
}